import type { Metadata } from "next";
import FaqPageClient from "@/components/FaqPageClient";
import { faqPageJsonLd } from "@/lib/faq-content";

export const metadata: Metadata = {
  title: "FAQ | FTO",
  description: "Clear answers about FTO, global outsourcing, delivery models, industries, and the role of AI and human judgment.",
};

export default function FaqPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqPageJsonLd).replace(/</g, "\\u003c"),
        }}
      />
      <FaqPageClient />
    </>
  );
}
